import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S04 = () => {
  return (
    <section className={cx('container')}>
      <div className={cx('header')}>
        <h1 className={cx('title')}>SASSY</h1>
      </div>
      <article className={cx('content')}>
        {/* <p className={cx('subtitle')}>두 번째 약속! 함께하는 즐거움</p> */}
        <h4 className={cx('title')}>SASSY</h4>
        <p className={cx('desc')}>
          From kids to parents,
          <br />
          LEVRAI creates joyful skincare moments for the whole family.
        </p>
        <ul className={cx('simpleList')}>
          <li>
            <h5>SASSY #1</h5>
            <span />
            <p>Trendy designs kids love to use and show off</p>
          </li>
          <li>
            <h5>SASSY #2</h5>
            <span />
            <p>A refined look and feel parents trust and appreciate</p>
          </li>
        </ul>
        {/* <img className={cx('logo')} src={require('../../../asset/images/global/logo_white.png')} alt="ENSEMBLE" /> */}
        {/* <p className={cx('note')}>스킨케어와 메이크업, 놀이 속 교집합의 영역을 르브레가 항상 함께하겠다는 의미로 탄생하였습니다.</p> */}
      </article>
    </section>
  );
};

export default S04;
